import ReportCommunityChatScreen from '~components/new-chat/community/template/[templateId]/report'

export default ReportCommunityChatScreen
